import React from 'react';
import './LocationScopeBadge.css';

function LocationScopeBadge({ className = '', title = 'Location-scoped' }) {
  return (
    <span
      className={['location-scope-badge', className].filter(Boolean).join(' ')}
      title={title}
      aria-label={title}
      role="img"
    >
      📍
    </span>
  );
}

export default LocationScopeBadge;
